export class ApiWrapper {
    static readonly apiHost: string = process.env.NX_BACKEND_URL;
    static readonly apiPort: string = process.env.NX_BACKEND_PORT;

    static performRequest(method: string, path: string, options, withAuth = false): Promise<never> {
        const requestOptions = {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: null
        };

        if (withAuth) {
            const tokenData = JSON.parse(localStorage.getItem('user-token'));
            if (!tokenData) {
                window.location.reload();
            }
            requestOptions.headers['Authorization'] = 'Bearer ' + tokenData['accessToken'];
        }

        switch (method) {
            case 'POST':
            case 'PATCH':
            case 'PUT': {
                requestOptions.body = JSON.stringify(options.body);
                break;
            }
            default:
        }


        return fetch(`${this.apiHost}:${this.apiPort}${path}`,
            requestOptions)
            .then(data => data.json())
            .catch(e => {
                console.log(`ERROR. URL: ${this.apiHost}:${this.apiPort}${path}. ${e}`);
                localStorage.removeItem('user-token');
                throw e;
            }) as never;
    }
}
